import { type FC } from 'react'
import { observer } from 'mobx-react-lite'

import { FilterDropdown, type IFilterDropdownProps } from './FilterDropdown'

type IFilterEditorAddProps = Omit<IFilterDropdownProps, 'onSelect'> & {
  onChange?: (key: string) => void
}

export const FilterEditorAdd: FC<IFilterEditorAddProps> = observer(
  ({ store, onChange, ...props }) => {
    const createFilter = (key: string) => {
      store.groups.createGroup().createFilter(key)
      onChange?.(key)
    }

    return <FilterDropdown {...props} store={store} onSelect={createFilter} />
  }
)
